import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	document: null,
	loading: false,
	loadingSubmit: false
};

export default function documentPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_DOCUMENT_REQUEST:
		case ActionTypes.GET_DOCUMENT_ERROR:
		case ActionTypes.GET_DOCUMENT_SUCCESS:
		case ActionTypes.SUBMIT_DOCUMENT_REQUEST:
		case ActionTypes.SUBMIT_DOCUMENT_ERROR:
		case ActionTypes.SUBMIT_DOCUMENT_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_DOCUMENT_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_DOCUMENT_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
